/*eslint-disable*/
import Vue from 'vue'
import ru from 'vee-validate/dist/locale/ru';
import bg from 'vee-validate/dist/locale/bg';
import uk from 'vee-validate/dist/locale/uk';
import VeeValidate, {Validator} from 'vee-validate';
// import Trainer from './config/trainer';
import _ from 'lodash';

const timeIntervalValidation = value => /^\s*([01]\d|2[0-3]):([0-5]\d)\s*-\s*([01]\d|2[0-3]):([0-5]\d)\s*$/.test(value);

Validator.extend('timeIntervalFormat', {
    getMessage: field => field + 'is incorrect',
    validate: value => {
        value = value.replace(/\s/g, "");
        return timeIntervalValidation(value);
    }
});

Validator.extend('timeInterval', {
   getMessage: field => field + 'is incorrect',
   validate: value => {
       value = value.replace(/\s/g, "");
       let flag = timeIntervalValidation(value);
        if (flag) {
            let startTime = value.split('-')[0];
            let endTime = value.split('-')[1];
            let startHours = startTime.split(':')[0];
            let startMinutes = startTime.split(':')[1];
            let endHours = endTime.split(':')[0];
            let endMinutes = endTime.split(':')[1];
            if (startHours !== endHours) {
                return startHours < endHours;
            } else {
                return startMinutes < endMinutes;
            }
        }
        return flag;
   }
});

Validator.extend('configuredGame', {
    getMessage: field => field + 'is incorrect',
    validate: (game) => {
        let valid = false;
        let properGame = _.find(Trainer.games, item => item.slug === game.slug);
        if (properGame) {
            properGame.validation.forEach(validation => {
                if (validation.rule === 'atLeastOne') {
                    for (let i = 0; i < validation.fields.length; i++) {
                        let field = validation.fields[i];
                        if (game.parameters.default[field].length > 0) {
                            valid = true;
                            break;
                        }
                    }
                } else if (validation.rule === 'shouldSelected') {
                    for (let i = 0; i < validation.fields.length; i++) {
                        let field = validation.fields[i];
                        let flag = false
                        for (let key in game.parameters.default[field]) {
                            if (game.parameters.default[field][key] instanceof Array) {
                                game.parameters.default[field][key].length > 0 && (flag = true)
                            } else if (game.parameters.default[field][key]) {
                                flag = true;
                                break;
                            }
                        }
                        valid = flag;
                    }
                }
            });
        }
        return valid;
    }
});

// Add locale helper.
Validator.localize('ru', ru);
const validationConfig = {
    errorBagName: 'errors', // change if property conflicts.
    locale: 'ru',
    dictionary: {
        ru: {
            messages: {
                confirmed: function (n, e) {
                    return "Поле " + n + " не совпадает с полем подтверждения."
                },
                timeIntervalFormat: function () {
                    return "Поле время указано не верно. Формат поля 10:00-12:00 (24 часа). "
                },
                timeInterval: function () {
                    return "Время начала должно быть меньше времени окончания."
                },
                configuredGame: function () {
                    return 'Игра настроена не верно.'
                }
            }
        },
        bg,
        uk,
        fr: {
            messages: {
                required (field) {
                    return `Le ${field} de connexion est obligatoire`;
                },
                min (field, amount) {
                    return `Le ${field} doit contenir au moins ${amount} caractères`;
                },
            }
        }
    },
    classNames: {
        invalid: 'is-danger', // model is invalid
    },
};
Vue.use(VeeValidate, validationConfig);
